import {
  Message,
  Modal,
  SectionCard,
  SliderMain,
  Spinner,
} from "dab-component-lib";
import React from "react";
import { compose, graphql, withApollo } from "react-apollo";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { toggleUserType } from "../../actions/index";
import I18n from "../../I18n/I18n";
import {
  categoriesTaxonomyQuery,
  getHomeProductsCategories,
  getQuantitiesByRegion,
  getText,
  mainSlider,
  productCategories,
} from "../../queries";
import {
  ErrorStyle,
  GridContainerStyle,
  LoadingStyle,
} from "../../utils/style-utils";
import { CardIntroStyle, CardRowStyle } from "./style";

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newUser: false,
      welcome: false,
      slides: [],
      randomProductsCategories: [],
      loading: true,
    };
  }

  componentDidMount() {
    if (this.props.userType.new_user) {
      this.setState({ newUser: true });
    }
    if (
      document.referrer === "https://sso.dabpumps.com/user/register?app=dshop"
    ) {
      this.setState({ welcome: true });
    }
  }

  closeModal = () => {
    this.setState({ newUser: false });
    this.props.dispatch(toggleUserType(false));
  };

  closeWelcomeModal = () => {
    this.setState({ welcome: false });
  };

  goToProduct = (data) => {
    const { url, isExternal } = data;
    const { history } = this.props;

    if (isExternal) {
      window.open(url);
    } else {
      history.push(url);
    }
  };

  render() {
    const { history, productCategories, categoriesTaxonomyQuery } = this.props;
    let categories = [];
    let categoriesSlider = [];

    if (productCategories.loading || categoriesTaxonomyQuery.loading) {
      return (
        <LoadingStyle>
          <Spinner size={150} />
        </LoadingStyle>
      );
    }

    if (productCategories.error || categoriesTaxonomyQuery.error) {
      return (
        <ErrorStyle>
          <Message title={I18n.t("errors.pageLoadingError")} />
        </ErrorStyle>
      );
    }

    if (
      !productCategories.loading &&
      !categoriesTaxonomyQuery.loading &&
      !productCategories.error &&
      !categoriesTaxonomyQuery.error
    ) {
      categoriesTaxonomyQuery.taxonomygenericviewGraphql1View.results.forEach(
        (category) => {
          if (category.fieldPromotedToFrontPage === true) {
            categories.push(category);
          }
        }
      );
      categories = categories.sort((a, b) => {
        return a.weight > b.weight ? 1 : b.weight > a.weight ? -1 : 0;
      });
      let parents =
        categoriesTaxonomyQuery.taxonomygenericviewGraphql1View.results.filter(
          (cat) => cat.parent[0].targetId === 0
        );
      categoriesSlider = parents.map((parent) => ({ ...parent, children: [] }));
      let children =
        categoriesTaxonomyQuery.taxonomygenericviewGraphql1View.results.filter(
          (cat) => cat.parent[0].targetId !== 0
        );
      children.forEach((category) => {
        categoriesSlider = categoriesSlider.map((cat) =>
          cat.tid === category.parent[0].targetId
            ? { ...cat, children: cat.children.concat([category]) }
            : cat
        );
      });
    }

    const slides = [];
    const { mainSlider, getTextModal1, getTextModal2 } = this.props;
    if (!mainSlider.loading && !mainSlider.error) {
      if (
        mainSlider.mainSliderGraphql1View.results.length > 0 &&
        mainSlider.mainSliderGraphql1View.results[0].fieldSlides &&
        mainSlider.mainSliderGraphql1View.results[0].fieldSlides.length > 0
      ) {
        mainSlider.mainSliderGraphql1View.results[0].fieldSlides.forEach(
          (slide) => {
            slides.push({
              action: {
                label: slide.entity.fieldLink
                  ? slide.entity.fieldLink.title
                  : slide.entity.fieldInternalLinkText,
                url: slide.entity.fieldLink
                  ? slide.entity.fieldLink.url.path
                  : `/product-detail/${slide.entity.fieldProductReference.targetId}`,
              },
              backgroundImage: slide.entity.fieldBackgroundImage.url,
              description: slide.entity.fieldDescription,
              imageUrl: slide.entity.fieldImage.url,
              title: slide.entity.fieldTitle,
            });
          }
        );
      }
    }

    if (getTextModal1.loading || getTextModal2.loading) {
      return (
        <LoadingStyle>
          <Spinner size={150} />
        </LoadingStyle>
      );
    }
    if (getTextModal1.error || getTextModal2.error) {
      return (
        <div>
          <h3>{I18n.t("errors.generalError")}</h3>
        </div>
      );
    }
    return (
      <div>
        <Modal open={this.state.newUser}>
          <div>
            <Message
              action={{
                label: I18n.t("buttons.visitSite"),
                onClick: this.closeModal,
              }}
              title={
                getTextModal2.translationMetadataGraphql1View.results.length >
                  0 &&
                getTextModal2.translationMetadataGraphql1View.results[0]
                  .fieldMainText
              }
              description={
                getTextModal2.translationMetadataGraphql1View.results.length >
                  0 &&
                getTextModal2.translationMetadataGraphql1View.results[0]
                  .fieldSubText
              }
            />
          </div>
        </Modal>
        <Modal open={this.state.welcome}>
          <div>
            <Message
              action={{
                label: I18n.t("buttons.close"),
                onClick: this.closeWelcomeModal,
              }}
              title={
                getTextModal1.translationMetadataGraphql1View.results.length >
                  0 &&
                getTextModal1.translationMetadataGraphql1View.results[0]
                  .fieldMainText
              }
              description={
                getTextModal1.translationMetadataGraphql1View.results.length >
                  0 &&
                getTextModal1.translationMetadataGraphql1View.results[0]
                  .fieldSubText
              }
            />
          </div>
        </Modal>
        <GridContainerStyle>
          {!mainSlider.loading && !mainSlider.error && (
            <SliderMain
              handleNavigateTo={(props) => this.goToProduct(props)}
              slides={slides}
            />
          )}
          <CardIntroStyle>
            <h2>{I18n.t("content.ourProduct")}</h2>
          </CardIntroStyle>
          <CardRowStyle>
            {categories.slice(0, 4).map((category, index) => {
              return (
                <SectionCard
                  description={
                    category.fieldDescription ? category.fieldDescription : ""
                  }
                  handleGoToDetail={() =>
                    history.push(`/category/${category.tid}`)
                  }
                  icon={
                    category.fieldIconName
                      ? category.fieldIconName.entity.name
                      : "DocumentationSectionIcon"
                  }
                  name={category.name}
                  key={index}
                  lang={
                    localStorage.getItem("language")
                      ? localStorage.getItem("language")
                      : "it"
                  }
                />
              );
            })}
          </CardRowStyle>
        </GridContainerStyle>
      </div>
    );
  }
}

const mapStateToProps = ({ userType }) => {
  return { userType };
};

export default connect(mapStateToProps)(
  compose(
    graphql(productCategories, {
      name: "productCategories",
      options: () => ({
        variables: {
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    }),
    graphql(categoriesTaxonomyQuery, {
      name: "categoriesTaxonomyQuery",
      options: () => ({
        variables: {
          vid: "product_categories",
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    }),
    graphql(mainSlider, {
      name: "mainSlider",
      options: () => ({
        variables: {
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    }),
    graphql(getHomeProductsCategories, {
      name: "getHomeProductsCategories",
      options: () => ({
        variables: {
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
        fetchPolicy: "network-only",
      }),
    }),
    graphql(getQuantitiesByRegion, {
      name: "getQuantitiesByRegion",
      options: () => ({
        variables: {
          field_product_category_target_id: null,
          id: null,
          name: localStorage.getItem("userRegion")
            ? localStorage.getItem("userRegion")
            : "ITALY",
        },
      }),
    }),
    graphql(getText, {
      name: "getTextModal1",
      options: () => ({
        variables: {
          machineName: "home_modal_new_user",
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    }),
    graphql(getText, {
      name: "getTextModal2",
      options: () => ({
        variables: {
          machineName: "home_modal_complete_registered",
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    })
  )(withRouter(withApollo(Home)))
);



// WEBPACK FOOTER //
// ./src/components/home/index.js